import { Grid, Heading, Layout } from '@enterprise-ui/canvas-ui-react'

export const SectionHeader = ({ pageHeading, pageActions }) => {
  return (
    <Layout.SectionHeader>
      <div className="hc-pa-dense hc-pb-none">
        <Grid.Container spacing="normal" justify="space-between">
          {pageHeading && (
            <Grid.Item>
              <Heading data-testid="sectionHeaderHeading" size={3}>
                {pageHeading}
              </Heading>
            </Grid.Item>
          )}
          {pageActions && <Grid.Item>{pageActions}</Grid.Item>}
        </Grid.Container>
      </div>
    </Layout.SectionHeader>
  )
}
